import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';

import EventDetails from 'components/UI/Event/EventDetails';

const EventDetailsStyled = withStyles(theme => ({
  
  root: {
    color: '#343E48',
    '& .MuiTypography-h5': {
      color: theme.palette.primary.main,
      fontWeight:'bold',
    },
    '& .HomeHelpContainer':{
      display:'none',
    }
  },
  left: {
    height:'auto',
    padding: theme.spacing(5),
    '& .MuiTypography-h4': {
      color: theme.palette.secondary.main,
      fontWeight:'bold',
    },
    '& .MuiTypography-body1': {
      color: theme.palette.text.light,
      fontWeight:'bold',
    },
    '& .MuiTypography-caption': {
      color: theme.palette.text.light,
    }
  },
  right:{
    padding: theme.spacing(5),
  },
  itemThumb: {
    backgroundColor:'unset',
    '&:before': {
      backgroundColor:'#b6c921',
      backgroundImage:'url('+(require('assets/images/event_detail.svg'))+')',
      backgroundPosition:'unset',
    }
  },
  titleIcon: {
    borderColor: theme.palette.primary.main,
    backgroundColor: '#fff'
  },
  rightGrid:{
    backgroundColor:'#f4f5f5',
  },
}))(EventDetails)

class EventDetailsWrapper extends Component {

  componentDidMount() {
    /*const {eventId}=this.props;
    if(eventId=='c78a02c687821c10f89e9637c357e1c8')
      this.tracking();
      */
  }

  tracking(){
    console.log("tracking!");
    window._adftrack = Array.isArray(window._adftrack) ? window._adftrack : (window._adftrack ? [window._adftrack] : []);
    window._adftrack.push({
        HttpHost: 'track.adform.net',
        pm: 1644357,
        divider: encodeURIComponent('|'),
        pagename: encodeURIComponent('FR_BIOCODEX_UNIVERSITEDUMICROBIOTE')
    });
    (function () { var s = document.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = 'https://s2.adform.net/banners/scripts/st/trackpoint-async.js'; var x = document.getElementsByTagName('script')[0]; x.parentNode.insertBefore(s, x); })();
  }

  
  render() {
    return (<EventDetailsStyled templateProps={{kind: 'fullWidth', maxWidth: 'auto'}} {...this.props}/>)
  }
}

export default EventDetailsWrapper;



// WEBPACK FOOTER //
// ./src/components/Event/EventDetails.jsx